if (!customElements.get('km-product-gallery')) {
 customElements.define('km-product-gallery', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return; this.ready=true;
   this.mobileLayout=window.matchMedia('(max-width: 749px)');
   const band=this.closest('.km-gallery-band');
   const home=document.createComment('Product photo gallery desktop position');
   if(band) band.before(home);
   const updateLayout=()=>{
    this.slides=[...this.querySelectorAll('[data-slide]')].filter(s=>!s.hasAttribute('data-desktop-excluded'));
    this.thumbs=[...this.querySelectorAll('[data-index]')].filter(t=>!t.hasAttribute('data-desktop-excluded'));
    this.thumbs.forEach((t,i)=>{t.dataset.index=i;t.setAttribute('aria-label','View image '+(i+1));});
    const thumbs=this.querySelector('.km-gallery__thumbs');
    if(thumbs)thumbs.hidden=this.slides.length<2;
    if(band){
     const product=document.querySelector('[data-testid="product-information"]')?.closest('.shopify-section');
     if(this.mobileLayout.matches&&product){if(product.previousElementSibling!==band)product.before(band);}
     else if(home.isConnected&&home.nextSibling!==band) home.after(band);
     band.hidden=!this.slides.length;
    }
    this.querySelectorAll('[data-step]').forEach(b=>b.hidden=this.slides.length<2);
    this.show(0);
    syncVariant();
   };
   const variants=JSON.parse(this.querySelector('[data-gallery-variants]')?.textContent||'[]');
   const syncVariant=(variant)=>{
    if(!this.mobileLayout.matches)return;
    if(!variant){
     const picker=document.querySelector('variant-picker');
     const selected=[...(picker?.querySelectorAll('input:checked, select option:checked')||[])].map(input=>input.value);
     variant=variants.find(v=>selected.length&&selected.every((value,i)=>v.options[i]===value));
     if(!variant)variant=variants.find(v=>String(v.id)===new URLSearchParams(location.search).get('variant'));
    }
    // Slides use product image IDs, which differ from Shopify media IDs.
    const id=variant?.featured_image?.id||variants.find(v=>String(v.id)===String(variant?.id))?.featured_image?.id;
    const index=this.slides.findIndex(slide=>String(slide.dataset.mediaId)===String(id));
    if(index>=0)this.show(index);
   };
   this.mobileLayout.addEventListener('change',updateLayout);
   document.addEventListener('change',event=>{if(event.target.closest?.('variant-picker'))syncVariant();});
   document.addEventListener('shopify:product:select',event=>{event.promise?.then(result=>syncVariant(result.detail?.resource)).catch(()=>{});});
   updateLayout();
   this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-expand')){const dialog=this.closest('dialog');if(dialog)dialog.close();else this.openFullscreen();}else if(b.hasAttribute('data-index'))this.show(Number(b.dataset.index));else if(b.dataset.step)this.show(this.index+Number(b.dataset.step));});
   const stage=this.querySelector('.km-gallery__stage');
   stage.addEventListener('pointerdown',e=>{
    if(!e.isPrimary){this.swipe=null;return;}
    if(e.pointerType!=='touch'||e.target.closest('button'))return;
    this.swipe={id:e.pointerId,x:e.clientX,y:e.clientY};
    stage.setPointerCapture(e.pointerId);
   });
   stage.addEventListener('pointerup',e=>{
    const start=this.swipe;this.swipe=null;
    if(!start||start.id!==e.pointerId)return;
    const dx=e.clientX-start.x,dy=e.clientY-start.y;
    if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.3)this.show(this.index+(dx<0?1:-1));
   });
   stage.addEventListener('pointercancel',()=>{this.swipe=null;});
   stage.addEventListener('lostpointercapture',()=>{this.swipe=null;});
   this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
  }
  openFullscreen(){
   const dialog=document.createElement('dialog');dialog.className='km-gallery-dialog';dialog.setAttribute('aria-label','Product gallery fullscreen');
   const gallery=this.cloneNode(true);gallery.removeAttribute('id');dialog.append(gallery);document.body.append(dialog);
   const button=gallery.querySelector('[data-expand]');button.setAttribute('aria-label','Close fullscreen gallery');gallery.querySelector('[data-expand-icon]').setAttribute('hidden','');gallery.querySelector('[data-close-icon]').removeAttribute('hidden');
   const previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
   dialog.addEventListener('close',()=>{this.show(gallery.index);document.documentElement.style.overflow=previousOverflow;dialog.remove();this.querySelector('[data-expand]').focus({preventScroll:true});},{once:true});
   dialog.showModal();gallery.show(this.index);button.focus();
  }
  show(index){if(!this.slides.length)return;this.querySelectorAll('[data-slide]').forEach(s=>s.hidden=true);this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.thumbs.forEach((t,i)=>t.setAttribute('aria-current',String(i===this.index)));const status=this.querySelector('[data-status]');if(status)status.textContent=this.slides[this.index].querySelector('img')?.alt||'Gallery image';const thumb=this.thumbs[this.index];if(thumb)thumb.parentElement.scrollTo({left:thumb.offsetLeft-thumb.parentElement.offsetLeft-thumb.parentElement.clientWidth/2+thumb.clientWidth/2,behavior:'smooth'});}
 });
}
